import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsActivisionComponent } from './simple-icons-activision.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsActivisionComponent ],
    exports:      [ SimpleIconsActivisionComponent ],
    bootstrap:    []
})
export class SimpleIconsActivisionModule {}
